import React from "react";
import "./FooterNews.css";

const FooterNews = () => {
    return (
        <footer className="footer1">
            <div className="footer-container1">
                <div className="element-wrapper1">
                    <img
                        className="element-61"
                        alt="Element"
                        src="https://c.animaapp.com/mdgpppf7nmySsB/img/----------2.png"
                    />
                </div>
                <div className="footer-text1">
                    <p>© 2025 Страховая компания “*****”</p>
                    <p>Все права защищены</p>
                </div>
            </div>
        </footer>
    );
};

export default FooterNews;
